import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('demo-content/auth/login')));
const AuthRegister = Loadable(lazy(() => import('demo-content/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('demo-content/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('demo-content/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('demo-content/auth/code-verification')));
const PrivacyPolicyTerms = Loadable(lazy(() => import('demo-content/auth/privacy-policy-terms')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/account',
  element: (
    <GuestGuard>
      <CommonLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: '/account/login',
      element: <AuthLogin />
    },
    {
      path: '/account/register',
      element: <AuthRegister />
    },
    {
      path: '/account/forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: '/account/reset-password',
      element: <AuthResetPassword />
    },
    {
      path: '/account/code-verification',
      element: <AuthCodeVerification />
    },
    {
      path: '/account/privacy-policy-terms',
      element: <PrivacyPolicyTerms />
    }
  ]
};

export default LoginRoutes;
